import useSWRImmutable from 'swr/immutable';

import { publicConfig } from '@public-config';

import type { DiagramGlobals, ExampleProfileGlobal, HighlightGlobals } from 'models';

import { ApiService } from 'services/ApiService';

const useDiagramGlobals = () => useGeneralGlobals<DiagramGlobals>('diagram');

const useHighlightGlobals = () => useGeneralGlobals<HighlightGlobals>('highlights');

const useExampleProfile = () => {
    const { data } = useGeneralGlobals<ExampleProfileGlobal>('example-profile');

    return data?.exampleProfile;
};

const globalsKey = (endpoint: string) => `/api/globals/general/${endpoint}`;

const useGeneralGlobals = <Response>(endpoint: string) => {
    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    const key = pathname === '/sorry' ? null : globalsKey(endpoint);

    return useSWRImmutable<Response>(key, () => ApiService.get(`${publicConfig.urls.api}/globals/general/${endpoint}`));
};

export { useDiagramGlobals, useExampleProfile, useHighlightGlobals };
